import RequestSender from '@/infrastructure/request-sender';
import { BaseSuperAgentRequestFactory } from '@studyportals/mb-platform-http-requests';
import { LurchClient } from '@studyportals/sp-lurch-interface';

const lurchUrl = webpackDefinitions.VUE_APP_LURCH_URL;
const lurchClient = new LurchClient(new BaseSuperAgentRequestFactory(), RequestSender, lurchUrl);

export default lurchClient;
